import React, {useState} from 'react';

import {SemanticLoader as Loader} from '../../../components/utility/InstrumentedLoader';
import {useFetchProjectJobsQuery} from '../../../generated/graphql';
import {Analytics} from '../../../services/analytics';
import {usePublicQueueAccess} from '../hooks';
import {JobDrawer} from '../JobDrawer/JobDrawer';
import {WANDB_ENTITY_NAME, WANDB_JOBS_PROJECT_NAME} from '../publicQueueUtils';
import {getPublicJobInfo} from './jobUtil';
import {PublicJobCard} from './PublicJobCard';
import * as S from './PublicJobsGettingStartedSection.styles';

export const PublicJobsGettingStartedSection: React.FC<{}> = () => {
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null);

  const {hasPublicQueueAccess, isFeatureFlagLoading} = usePublicQueueAccess();
  const publicJobsQuery = useFetchProjectJobsQuery({
    variables: {
      entityName: WANDB_ENTITY_NAME,
      projectName: WANDB_JOBS_PROJECT_NAME,
    },
    skip: !hasPublicQueueAccess,
  });

  if (isFeatureFlagLoading || publicJobsQuery.loading) {
    return <Loader active name="jobs-page-landing-loader" />;
  }

  const publicJobEdges: any[] =
    publicJobsQuery.data?.project?.artifactType?.artifactCollections?.edges ??
    [];

  const publicJobs = getPublicJobInfo(
    publicJobEdges,
    WANDB_ENTITY_NAME,
    WANDB_JOBS_PROJECT_NAME
  );

  const onJobLaunch = (jobId: string) => {
    setSelectedJobId(jobId);
    Analytics.track('clicked launch public job', {
      jobId,
      location: 'zero jobs page',
    });
  };

  const closeDrawer = () => {
    setSelectedJobId(null);
  };

  if (publicJobs.length === 0) {
    return null;
  }

  return (
    <S.PublicJobsContainer>
      <S.SmallHeading>Get started with W&B public jobs</S.SmallHeading>
      <S.JobsContainer>
        {publicJobs.map(job => (
          <PublicJobCard
            key={job.id}
            job={job}
            onLaunch={() => onJobLaunch(job.id)}
          />
        ))}
      </S.JobsContainer>

      <JobDrawer
        open={selectedJobId != null}
        closeDrawer={closeDrawer}
        entityName={WANDB_ENTITY_NAME}
        projectName={WANDB_JOBS_PROJECT_NAME}
        defaultJobId={selectedJobId ?? undefined}
        defaultJobVersion="latest"
      />
    </S.PublicJobsContainer>
  );
};
